<h3>Mitteilungen an den Auftraggeber</h3>
<clr-datagrid *ngIf="!!notification61" [clrDgLoading]="loading">
  <clr-dg-column [clrDgField]="'project_id'">Mitteilung</clr-dg-column>
  <clr-dg-column [clrDgField]="'project_id'">Datum</clr-dg-column>
  <clr-dg-column [clrDgField]="'company_name'">Empfänger</clr-dg-column>
  <clr-dg-column [clrDgField]="'subject'">Betreff</clr-dg-column>
  <clr-dg-column [clrDgField]="'order_id'">Bestellnummer des Kunden</clr-dg-column>
  <clr-dg-column [clrDgField]="'name_project'">Projektname</clr-dg-column>
  <clr-dg-placeholder>We couldn't find any Notification!</clr-dg-placeholder>
  <clr-dg-row *clrDgItems="let notification of notification61">
    <clr-dg-cell [routerLink]="['/notification/details/', notification.project_id, notification.job_id, notification.notification_id]">{{ notification.project_id }}.0007.{{ notification.notification_id }}</clr-dg-cell>
    <clr-dg-cell>{{ notification.notification_date | date: "dd.MM.yyyy" }}</clr-dg-cell>
    <clr-dg-cell>{{ notification.company_name }}</clr-dg-cell>
    <clr-dg-cell>{{ notification.subject }}</clr-dg-cell>
    <clr-dg-cell>{{ notification.order_id }}</clr-dg-cell>
    <clr-dg-cell><b>{{ notification.name_project }}</b></clr-dg-cell>
  </clr-dg-row>
  <clr-dg-footer>
    <clr-dg-pagination #pagination [clrDgPageSize]="50">
      <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Jobs pro Seite</clr-dg-page-size>
      {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
      von {{notification61.length}} Job(s)
    </clr-dg-pagination>
  </clr-dg-footer>
</clr-datagrid>

<h3>Mitteilungen an Lieferanten</h3>
<clr-datagrid *ngIf="!!notification60" [clrDgLoading]="loading">
  <clr-dg-column [clrDgField]="'project_id'">Mitteilung</clr-dg-column>
  <clr-dg-column [clrDgField]="'project_id'">Datum</clr-dg-column>
  <clr-dg-column [clrDgField]="'company_name'">Empfänger</clr-dg-column>
  <clr-dg-column [clrDgField]="'subject'">Betreff</clr-dg-column>
  <clr-dg-column [clrDgField]="'order_id'">Bestellnummer des Lieferanten</clr-dg-column>
  <clr-dg-column [clrDgField]="'name_project'">Projektname</clr-dg-column>
  <clr-dg-placeholder>We couldn't find any Notification!</clr-dg-placeholder>
  <clr-dg-row *clrDgItems="let notification of notification60">
    <clr-dg-cell [routerLink]="['/notification/details/', notification.project_id, notification.job_id, notification.notification_id]">{{ notification.project_id }}.0007.{{ notification.notification_id }}</clr-dg-cell>
    <clr-dg-cell>{{ notification.notification_date | date: "dd.MM.yyyy" }}</clr-dg-cell>
    <clr-dg-cell>{{ notification.company_name }}</clr-dg-cell>
    <clr-dg-cell>{{ notification.subject }}</clr-dg-cell>
    <clr-dg-cell>{{ notification.purchasing_id }}</clr-dg-cell>
    <clr-dg-cell><b>{{ notification.name_project }}</b></clr-dg-cell>
  </clr-dg-row>
  <clr-dg-footer>
    <clr-dg-pagination #pagination [clrDgPageSize]="50">
      <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Jobs pro Seite</clr-dg-page-size>
      {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
      von {{notification60.length}} Job(s)
    </clr-dg-pagination>
  </clr-dg-footer>
</clr-datagrid>

<!--
<pre class="datepicker-output">
    {{ notification | json }}
</pre>
-->
